export default new class SaleService {
    SALE_STATUS_WON = 'won';
    SALE_STATUS_LOST = 'lost';
    SALE_STATUS_CANCELLED = 'cancelled';
};